import React from 'react'
import { Snackbar } from '@mui/material'
import { XIcon } from '../svgIcons/XIcon'

function Toast(props: {
    type: string
    open: any
    onDelete: (arg0: any) => void
    hash: any
    msg: boolean | React.ReactChild | React.ReactFragment | React.ReactPortal | null | undefined
}) {
    const [open, setOpen] = React.useState(props.open)
    const { type } = props
    const handleClose = (_event: any, reason: string) => {
        if (reason === 'clickaway') {
            return
        }
        setOpen(false)
        props.onDelete(props.hash)
    }

    return (
        <Snackbar
            className='toast'
            open={open}
            onClick={() => handleClose('', '')}
            autoHideDuration={6000}
            key={props.hash}
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            sx={{ mt: 12 }}
            onClose={handleClose}>
            <div
                className={`flex items-center justify-between relative rounded-md text-[16px] py-2 px-4 ${
                    type === 'error' ? 'bg-[#391F45] text-[#FF5353]' : 'bg-[#0AE8F9] text-[#0C1647]'
                }`}>
                <div className='flex-1 mr-5'>{props.msg}</div>
                <XIcon onClick={handleClose} className='h-4 w-4 cursor-pointer' />
            </div>
        </Snackbar>
    )
}

export default Toast
